/**
 * ProtectedRoute Component
 * Updated to use AuthGuard with store requirements and customer-only restrictions
 */

import React from 'react';
import AuthGuard from './AuthGuard';

const ProtectedRoute = ({
  children,
  requireStore = true, // Most routes require a store
  customerOnly = false, // Routes that employees cannot access
  ...props
}) => {
  return (
    <AuthGuard requireStore={requireStore} customerOnly={customerOnly} {...props}>
      {children}
    </AuthGuard>
  );
};

export default ProtectedRoute;